import { render, staticRenderFns } from "./About.vue?vue&type=template&id=1925c7d6&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=1925c7d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1925c7d6",
  null
  
)

export default component.exports